<template>
  <div class="va-section-header">
    <h2 class="va-section-header-title">{{ title }}</h2>
    <a
      v-if="actionText"
      href="#"
      class="va-section-header-action"
      @click.prevent="$emit('action')"
      >{{ actionText }}</a
    >
  </div>
</template>

<style>
.va-section-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.va-section-header-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #193153;
  white-space: nowrap;
}

.va-section-header-action {
  font-size: 13px;
  font-weight: 500;
  color: #00728a;
  text-decoration: none;
  white-space: nowrap;
}

.va-section-header-action:hover {
  color: #193153;
}
</style>

<script>
export default {
  name: "HomeSectionHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    actionText: {
      type: String,
      default: null,
    },
  },
};
</script>
